function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

/**
 * The digits a US number would use, or null when the input cannot be one.
 *
 * This deliberately does NOT truncate. Slicing to the first ten digits turned
 * a pasted "+44 20 7946 0958" into "(442) 079-4609" — a different, valid US
 * number that the server then accepted and sent to the provider. Refusing to
 * mask is the honest outcome: the rider keeps seeing what they typed and the
 * server rejects it, which is what Bookings::PhoneNumber.normalize already does.
 */
function nationalDigits(value: string): string | null {
  const digits = digitsOnly(value);
  if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
  if (digits.length <= 10) return digits;
  return null;
}

/** Progressive US mask. Never emits trailing punctuation so backspace is caret-safe. */
export function formatUsPhone(value: string): string {
  const digits = nationalDigits(value);
  if (digits === null) return digitsOnly(value);

  const area = digits.slice(0, 3);
  const exchange = digits.slice(3, 6);
  const subscriber = digits.slice(6, 10);

  if (digits.length === 0) return "";
  if (digits.length < 3) return area;
  if (digits.length === 3) return `(${area}`;
  if (digits.length < 7) return `(${area}) ${exchange}`;
  return `(${area}) ${exchange}-${subscriber}`;
}

export function toE164(value: string): string | null {
  const digits = digitsOnly(value);
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+1${digits.slice(1)}`;
  return null;
}
